import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormQuestionService } from './../service/form-question-service';
import { ShipmentFormInfo } from './../service/form-field';
import { ShipmentFormService } from './../service/shipment-form-service';
import { ActivityLogger } from '../../../activities/activity-logger';
import { ShipmentFormStorage } from '../shipment-form-storage';
import { ActivatedRoute } from '@angular/router';
import { UrlBuilder } from '../../../core';
import { GridDetails } from '../../../sample-tracking/tracking-overview/interfaces/grid';
import { ContainerData } from '../../interfaces/shipment-form-data';
import * as moment from 'moment';
import { SiteSavedShipmentDetails, ContainerGridData } from './resume-shipment-info';

@Component({
    selector: 'resume-shipment',
    template: require('./resume-shipment.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResumeShipmentComponent {

    public shipmentFormGroup: FormGroup;
    public formData: ShipmentFormInfo = { };
    public showNotSavedAlert = false;
    public shipmentId: number;
    public gridDetails: GridDetails = {
        header: this.shipmentFormService.getShipmentTableHeader(),
        data: []
    };
    public isDataLoaded = false;
    public shipmentData: SiteSavedShipmentDetails;
    private containerData: ContainerData[] = [];

    constructor(
        private formQuestionService: FormQuestionService,
        private shipmentFormService: ShipmentFormService,
        private shipmentStorage: ShipmentFormStorage,
        private activatedRoute: ActivatedRoute,
        private urlBuilder: UrlBuilder,
        private changeDetectorRef: ChangeDetectorRef,
        activityLogger: ActivityLogger,
    ) {
        this.loadFormData();
        activityLogger.logActivity('Shipments - In Progress - Action : Resume Shipment');
    }

    public onFormSubmit(isSubmited: boolean) {
        this.showNotSavedAlert = false;
    }

    public formValueChangeEvent($event: boolean) {
        this.showNotSavedAlert = $event;
    }

    private loadFormData() {
        this.activatedRoute.params.subscribe(param => {
            this.shipmentId = Number(param.id);
            this.shipmentStorage.getInprogressShipmentDetails(this.shipmentId).subscribe((data: SiteSavedShipmentDetails) => {
                if (!data || !data.savedShipmentData) {
                    this.urlBuilder.esa().sampleManagement().siteShipping().inProgressShipmentList().navigate();
                } else {
                    if (data.savedShipmentData[0].submittedOn) {
                        this.urlBuilder.esa().sampleManagement().siteShipping().inProgressShipmentList().navigate();
                    }
                    this.formData.barcodes = data.containerGridData.map(t => t.barcodeRaw);
                    data.containerGridData.forEach((gd: ContainerGridData) => {
                        this.setGridData(gd);
                    });
                    this.formData.gridData = this.gridDetails;
                    this.formData.containerData = this.containerData;
                    this.formData.transferData = data.containerTransferData;
                    this.formData.currentFocus = false;
                    let savedShipmentData = data.savedShipmentData[0];
                    this.formData.containerCreationStartedOn = this.getDateValue(savedShipmentData.createdOn, 'DD-MMM-YY hh:mm:ss A Z');
                    savedShipmentData.scheduledShipmentDate = this.getDateValue(savedShipmentData.scheduledShipmentDate, 'DD-MMM-YYYY');
                    this.shipmentFormGroup = this.formQuestionService.loadInProgressFormData(savedShipmentData);
                    this.shipmentData = data;
                    this.formData.shipmentId = savedShipmentData.investigatorsiteshipmentId;
                    this.isDataLoaded = true;
                    this.changeDetectorRef.markForCheck();
                }
            });
        });
    }

    private setGridData(data: ContainerGridData) {
        data.userEnteredBarcode = data.userEnteredBarcode ? data.userEnteredBarcode : data.barcodeRaw;
        data = this.shipmentFormService.formatShipmentDetails(data);
        this.gridDetails.data.unshift(data);
        this.gridDetails = { ...this.gridDetails };
        this.containerData.push({
            accessionId: data.accessionId,
            barcode: data.barcodeRaw,
            containerId: data.containerID,
            userEnteredBarcode: data.userEnteredBarcode,
            investigatorSiteshipmentContainerId: data.investigatorsiteShipmentContainerId,
        });
    }

    private getDateValue(dateValue: string, dateFormat: string) {
        if (!dateValue || !dateFormat) { return ''; }
        return moment(dateValue).isValid ? moment(dateValue).format(dateFormat) : '';
    }
}